import React from 'react'

const UserEditTitle = ({ record }) => (
  <span>{record.name ? `${record.name}` : `${record.email}`}</span>
)

export default UserEditTitle
